import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCloudwaysComponent } from './simple-icons-cloudways.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCloudwaysComponent ],
    exports:      [ SimpleIconsCloudwaysComponent ],
    bootstrap:    []
})
export class SimpleIconsCloudwaysModule {}
